import axios from '../axios'
// 当前用户的菜单
export const postMenu = (data) => {
  return axios({
    url: '/con/manage/menu/get_menu_by_uid',
    method: 'POST',
    data
  })
}
// 其他用户的权限
export const get_role_menu = (data) => {
  return axios({
    url: '/con/manage/role/get_role_menu',
    method: 'POST',
    data
  })
}
// 查看全部菜单
export const getAllMenu= (data) => {
  return axios({
    url: '/con/manage/menu/get',
    method: 'POST',
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/menu.js